import { getStatusForId as getStatus } from '@ms/yammer-data-support';
import createCachedSelector from 're-reselect';

import type { User, UserNetworkLeader, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

/**
 * @deprecated PERFORMANCE This selects an entity object, which will return a new instance and force re-renders
 * when changed. This should be replaced by a `getUserNetworkLeaderField` selector.
 */
export const findById = createFindById('userNetworkLeaders');
/**
 * @deprecated PERFORMANCE This selects an entity object, which will return a new instance and force re-renders
 * when changed. This should be replaced by a `getUserNetworkLeaderFieldThrows` selector.
 */
export const findByIdThrows = createFindByIdThrows('userNetworkLeaders');

type GetFulfilledUserNetworkLeaders = (state: YammerState) => Record<string, UserNetworkLeader>;
/**
 * @deprecated PERFORMANCE This selects an object containing all fulfilled entities, which will return a new object
 * instance and force re-renders when ANY network leader changes in the store. This selector should be deleted.
 */
export const getFulfilledUserNetworkLeaders: GetFulfilledUserNetworkLeaders = (state) =>
  state.userNetworkLeaders.fulfilled.byId;

type GetStatusForId = (state: YammerState, userId: User['id']) => ReturnType<typeof getStatus>;
export const getStatusForId: GetStatusForId = (state, userId) => getStatus(state.userNetworkLeaders, userId);

type HasUserNetworkLeaders = (state: YammerState) => boolean;
export const hasUserNetworkLeaders: HasUserNetworkLeaders = createCachedSelector(
  getFulfilledUserNetworkLeaders,
  (fulfilledUserNetworkLeaders) => {
    const userNetworkLeaders = Object.values(fulfilledUserNetworkLeaders).filter(
      (fulfilledUserNetwork) => fulfilledUserNetwork.isLeader
    );

    return !!userNetworkLeaders.length;
  }
)((_state) => 'cache');
